import React, { useEffect, useRef, useState } from "react";
import {
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
} from "reactstrap";
import classnames from "classnames";
import { Link } from "react-router-dom";

// components
import LightBox from "../../../components/LightBox";
import LightBox2 from "../../../components/LightBox2";

//images
import imagePlaceholder from "../../../assets/images/users/user-dummy-img.jpg";

// interface
import {
  MessagesTypes,
  ImageTypes,
  AttachmentTypes,
} from "../../../data/messages";

// hooks
import { useProfile, useRedux } from "../../../hooks";

// utils
import { formateDate } from "../../../utils";
import RepliedMessage from "./RepliedMessage";
import SenderMsgInfo, { ReadPcntCircle } from "./SenderMsgInfo";
import { createSelector } from "reselect";

import { setPreviewAttachfile, setRespEmoji } from "../../../redux/actions";
import { Utils } from "helpers/utils";
import UserAvatar from "components/UserAvatar";
import { Const } from "const";
import { unsendMessage } from "../../../api/chats";
import AppSimpleBar from "components/AppSimpleBar";
import { UserTypes } from "api";
import Loader from "components/Loader";
import { APIClient } from "api/apiCore";
import * as url from "api/urls";


interface MenuProps {
  onDelete: () => any;
  onReply: () => any;
  onForward: () => void;
  msgId: any;
  isFromMe: boolean;
  showAiMenu: boolean;
}

const Menu = ({ onDelete, onReply, onForward, msgId, isFromMe, showAiMenu }: MenuProps) => {
  const { dispatch, useAppSelector } = useRedux();
  const storeData = createSelector(
    (state) => state.Profile2,
    (p2) => ({
      displayName: p2.displayName,
      curUserId: p2.userId,
    })
  );
  const { displayName, curUserId } = useAppSelector(storeData);
  // const showMsgMenu = false;
  // emoji list https://github.com/ikatyang/emoji-cheat-sheet
  const emojis = [
    { name: 'OK', icon: '🆗' },
    { name: 'Smile', icon: '😊' },
    { name: 'Cry', icon: '😢' },
    { name: 'Crying Smile', icon: '😂' },

    { name: 'Pleading', icon: '🥺' },
    { name: 'Salute', icon: '🫡' },
    { name: 'In love', icon: '🥰' },
    { name: 'Crying', icon: '😭' },

    { name: 'Good', icon: '👍' },
    { name: 'Thank you', icon: '🙏' },
    { name: 'Strong', icon: '💪' },
    { name: 'Crab', icon: '👏' },

    { name: 'Done', icon: '✅' },
    { name: 'No', icon: '❌' },
    { name: 'Smile Glasses', icon: '😎' },
    { name: 'Ok Hand', icon: '👌' },

    // { name: 'Plus 1', icon: '➕' },
    // { name: 'Minus 1', icon: '➖' },

    { name: '100%', icon: '💯' },
    { name: 'Love', icon: '❤️' },
    // { name: 'Negative', icon: '🆖' }, //{ name: 'Wait', icon: '⌛' },
    { name: 'Delivery', icon: '🚚' },
    { name: 'Soon', icon: '🔜' },

  ];

  const onEmojiClick = (name: any, icon: any) => {
    if (Utils.IsViewAsAlert()) return;
    try {
      // console.log('dispatch set emojic:', {msgId, name, icon, displayName});
      dispatch(setRespEmoji(msgId, name, icon, displayName));
      // console.log('dispatch set emojic: done');
    } catch (e) {
      alert((e as any).message);
    }
  };

  const onUnsendMessage = async () => {
    try {
      const rs = await unsendMessage(msgId);
      // console.log(rs);
      if (rs.err) {
        alert(rs.err);
      } else {
        // console.log('done');
      }
    } catch (e) {
      console.error(e);
      alert((e as any).message);
    }
  }

  const onReplyIn = async () => {
    if (Utils.IsViewAsAlert()) return;
    onReply();
  }

  const onUnsendMessageIn = async () => {
    if (Utils.IsViewAsAlert()) return;
    onUnsendMessage();
  }

  const onAskAi = async (msgId: string, curUserId: number) => {
    try {
      Utils.OpenUrlInSameTab(`https://api.2smetal.com/chatAI/extraction_page?msg_id=${msgId}&user_id=${curUserId}`, "chat2s_ask_ai");

    } catch (e) {
      Utils.HandleException(e, true);
    }
  }

  return (
    <>
      <UncontrolledDropdown className="align-self-start message-box-drop">
        <DropdownToggle className="btn btn-toggle" role="button" tag={"a"}>
          <i className="ri-more-2-fill"></i>
        </DropdownToggle>
        <DropdownMenu>

          <DropdownItem key={'A'} className="d-flex align-items-center justify-content-between" to="#" onClick={onReplyIn}>
            ตอบกลับ <i className="bx bxs-share ms-2 text-muted"></i>
          </DropdownItem>

          {showAiMenu && (
            <DropdownItem key={'A.1'} className="d-flex align-items-center justify-content-between" to="#" onClick={() => onAskAi(msgId, curUserId)}>
              AI หาสินค้า <i className="fas fa-robot ms-2 text-muted"></i>
            </DropdownItem>
          )}


          {isFromMe && (
            <DropdownItem key={'B'} className="d-flex align-items-center justify-content-between" to="#" onClick={onUnsendMessageIn}>
              ยกเลิกข้อความ <i className="bx bxs-message-x ms-2 text-muted"></i>
            </DropdownItem>
          )}


          <DropdownItem key={2} divider className="custom-divider" />
          <DropdownItem key={3} className="d-flex align-items-center justify-content-between" to="#" style={{ minWidth: "200px" }}>
            <div className="row">
              {emojis.map((emoji, index) => (
                <React.Fragment key={index}>
                  <div
                    // key={index}
                    className="col text-center msg-emoji-resp"
                    onClick={() => onEmojiClick(emoji.name, emoji.icon)}
                    style={{ cursor: 'pointer', fontSize: '1.8rem'/*, margin: '5px 0', width: "30px", height: "30px"*/ }}
                    title={emoji.name}
                  >
                    {emoji.icon}
                  </div>
                  {(index + 1) % 4 == 0 && (<div className="w-100"></div>)}
                </React.Fragment>
              ))}
            </div>
          </DropdownItem>

          {/* <DropdownItem
              className="d-flex align-items-center justify-content-between"
              to="#"
              onClick={onForward}
            >
              Forward <i className="bx bx-share-alt ms-2 text-muted"></i>
            </DropdownItem>
            <DropdownItem
              className="d-flex align-items-center justify-content-between"
              to="#"
            >
              Copy <i className="bx bx-copy text-muted ms-2"></i>
            </DropdownItem>
            <DropdownItem
              className="d-flex align-items-center justify-content-between"
              to="#"
            >
              Bookmark <i className="bx bx-bookmarks text-muted ms-2"></i>
            </DropdownItem>
            <DropdownItem
              className="d-flex align-items-center justify-content-between"
              to="#"
            >
              Mark as Unread <i className="bx bx-message-error text-muted ms-2"></i>
            </DropdownItem>
            <DropdownItem
              className="d-flex align-items-center justify-content-between delete-item"
              onClick={onDelete}
            >
              Delete <i className="bx bx-trash text-muted ms-2"></i>
            </DropdownItem> */}
        </DropdownMenu>
      </UncontrolledDropdown>


    </>
  );
};
interface ImageMoreMenuProps {
  imagelink: any,
  onReply: () => any;
  onDelete: () => void;
}
const ImageMoreMenu = ({ imagelink, onReply, onDelete }: ImageMoreMenuProps) => {
  return (
    <div className="message-img-link">
      <ul className="list-inline mb-0">
        <UncontrolledDropdown
          tag="li"
          color="none"
          className="list-inline-item dropdown"
        >
          <DropdownToggle tag="a" role="button" className="btn btn-toggle">
            <i className="bx bx-dots-horizontal-rounded"></i>
          </DropdownToggle>
          <DropdownMenu>

            <DropdownItem
              className="dropdown-item d-flex align-items-center justify-content-between"
              href={imagelink}
              download
            >
              Download <i className="bx bx-download ms-2 text-muted"></i>
            </DropdownItem>

            <DropdownItem
              tag="a"
              className=" d-flex align-items-center justify-content-between"
              href="#"
              onClick={onReply}
            >
              Reply <i className="bx bx-share ms-2 text-muted"></i>
            </DropdownItem>

            {/* <DropdownItem
              tag="a"
              className=" d-flex align-items-center justify-content-between"
              href="#"
              data-bs-toggle="modal"
              data-bs-target=".forwardModal"
            >
              Forward <i className="bx bx-share-alt ms-2 text-muted"></i>
            </DropdownItem> */}

            {/* <DropdownItem
              tag="a"
              className=" d-flex align-items-center justify-content-between"
              href="#"
            >
              Bookmark <i className="bx bx-bookmarks text-muted ms-2"></i>
            </DropdownItem> */}

            {/* <DropdownItem
              tag="a"
              className=" d-flex align-items-center justify-content-between delete-item"
              href="#"
              onClick={onDelete}
            >
              Delete <i className="bx bx-trash ms-2 text-muted"></i>
            </DropdownItem> */}

          </DropdownMenu>
        </UncontrolledDropdown>
      </ul>
    </div>
  );
};

interface ImageProps {
  message: MessagesTypes,
  image: ImageTypes;
  onImageClick: (id: number) => void;
  index: number;
  onSetReplyData: (reply: null | MessagesTypes | undefined) => void;
  onDeleteImg: (imageId: string | number) => void;
}
const Image = ({ message, image, onImageClick, index, onSetReplyData, onDeleteImg }: ImageProps) => {
  const onDelete = () => {
    onDeleteImg(image.id);
  };
  const onClickReply = () => {

    let multiimages: any = message['image'];

    let results = multiimages.filter((multiimage: any) => multiimage.id === image.id);

    message['newimage'] = results;

    onSetReplyData(message);

  };
  return (
    <React.Fragment>
      <div className="message-img-list">
        <div>
          <Link
            className="popup-img d-inline-block"
            to={"#"}
            onClick={() => onImageClick(index)}
          >
            <img src={image.downloadThumb ?? image.downloadLink} alt="" className="rounded border" />
          </Link>
        </div>
        {/* เปลี่ยนเป็นไม่ต้องมี menu ใน image เพราะ menu เอาไปรวมกับข้อความใน container หลัก เพื่อความสะดวกในการทำ emoji responde */}
        {/* <ImageMoreMenu imagelink={image.downloadLink} onReply={onClickReply} onDelete={onDelete} /> */}
      </div>
    </React.Fragment>
  );
};
interface ImagesProps {
  message: MessagesTypes,
  images: ImageTypes[];
  onSetReplyData: (reply: null | MessagesTypes | undefined) => void;
  onDeleteImg: (imageId: string | number) => void;
}
const Images = ({ message, images, onSetReplyData, onDeleteImg }: ImagesProps) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState(0);
  const [imageLoaded, setImageLoaded] = useState<any[]>([]);
  const onImageClick = (id: number) => {
    if (loading) return;
    setLoading(true);
    setSelected(id);
    const api = new APIClient();
    api.fnPostForm(url.CHAT_GET_CONVERSION_IMG, { msgId: message.mId })
      .then(rs => {
        setImageLoaded(rs);
        setLoading(false);
        setIsOpen(true);
      })
      .catch(er => {
        setLoading(false);
        Utils.HandleException(er, true);
      });
    // console.log('images:', { message, images });
  };
  const onClose = () => {
    setIsOpen(false);
  };

  return (
    <>
      <div className="message-img mb-0">
        {loading && (<Loader />)}
        {(images || []).map((image: ImageTypes, key: number) => (
          <Image
            message={message}
            image={image}
            key={key}
            index={key}
            onImageClick={onImageClick}
            onSetReplyData={onSetReplyData}
            onDeleteImg={onDeleteImg}
          />
        ))}
      </div>
      {/* {isOpen && (
        <LightBox
          isOpen={isOpen}
          images={images}
          onClose={onClose}
          defaultIdx={selected}
        />
      )} */}

      {isOpen && (
        <LightBox2
          isOpen={isOpen}
          images={imageLoaded}
          onClose={onClose}
          defaultIdx={selected}
          allowRotate={true}
        />
      )}
    </>
  );
};

interface AttachmentsProps {
  attachments: AttachmentTypes[] | undefined;
}
const Attachments = ({ attachments }: AttachmentsProps) => {
  const { dispatch, useAppSelector } = useRedux();
  const storeData = createSelector(
    (state) => state.Chats,
    (chat) => ({
      previewAttach: chat.previewAttach
    })
  );
  const { previewAttach } = useAppSelector(storeData);

  const onAttachmentClick = async (fileUrl: any) => {
    //console.log('open url: ' + fileUrl);
    window.open(fileUrl, "_blank");
    // dispatch(setPreviewAttachfile(link2));
  }

  const targetAttachedment = Utils.isApple ? "" : "_blank";
  return (
    <>
      {(attachments || []).map((attachment: AttachmentTypes, key: number) => (
        <div
          key={key}
          className={classnames("p-2", "border-primary", "border rounded-3", {
            "mt-2": key !== 0,
          })}
        >

          <a
            href={attachment.downloadLink ? attachment.downloadLink : "#"}
            className="text-muted"
            target={targetAttachedment}
            download={attachment.name}
          >
            <div className="d-flex align-items-center attached-file">
              <div className="flex-shrink-0 avatar-sm me-3 ms-0 attached-file-avatar">
                <div className="avatar-title bg-primary-subtle text-primary rounded-circle font-size-20">
                  <i className="ri-attachment-2"></i>
                </div>
              </div>
              <div className="flex-grow-1 overflow-hidden">
                <div className="text-start">
                  <h5 className="font-size-14 mb-1" style={{ wordBreak: "break-word" }}>{attachment.name}</h5>
                  <p className="text-muted text-truncate font-size-13 mb-0">
                    {attachment.desc}
                  </p>
                </div>
              </div>
              <div className="flex-shrink-0 ms-4">
                <div className="d-flex gap-2 font-size-20 d-flex align-items-start">
                  <div>
                    {/* <a
                    href={attachment.downloadLink ? attachment.downloadLink : "#"}
                    className="text-muted"
                    target="_blank"
                    download
                  >
                    <i className="bx bxs-download"></i>
                  </a> */}
                    <i className="bx bxs-download"></i>
                  </div>
                </div>
              </div>
            </div>
          </a>

        </div>
      ))}
    </>
  );
};

interface HtmlContentProps {
  htmlContent: any;
}
const HtmlContent = ({ htmlContent }: HtmlContentProps) => {
  return (
    <>
      <div
        className={classnames("p-2", "border-primary", "border rounded-3")}
        dangerouslySetInnerHTML={{ __html: htmlContent }}
      >
      </div>
    </>
  );
}

const Typing = () => {
  return (
    <p className="mb-0">
      typing
      <span className="animate-typing">
        <span className="dot mx-1"></span>
        <span className="dot me-1"></span>
        <span className="dot"></span>
      </span>
    </p>
  );
};

interface MessageProps {
  message: MessagesTypes;
  chatUserDetails: any;
  onDelete: (messageId: string | number) => any;
  onSetReplyData: (reply: null | MessagesTypes | undefined) => void;
  isFromMe: boolean;
  onOpenForward: (message: MessagesTypes) => void;
  isChannel: boolean;
  onDeleteImage: (messageId: string | number, imageId: string | number) => void;
  // onSetReplyImageData: () => void;
  onViewReadStatus: (mId: string) => void;
  onClickReplyMsg: (fromId: any, msgId: any) => void;
}
const Message = ({
  message,
  chatUserDetails,
  onDelete,
  onSetReplyData,
  isFromMe,
  onOpenForward,
  isChannel,
  onDeleteImage,
  onViewReadStatus,
  onClickReplyMsg
}: MessageProps) => {
  const { dispatch, useAppSelector } = useRedux();
  const storeData = createSelector(
    (state) => state.Profile2,
    (state) => state.Chats,
    (p2, cht) => ({
      displayName: p2.displayName,
      chatAlighRight: p2.chatAlighRight,
      curUserType: p2.userType,
      groupType: cht.chatUserDetails.contactType,

    })
  );
  const { displayName, chatAlighRight, curUserType, groupType } = useAppSelector(storeData);
  const message2 = message as any;
  const { userProfile } = useProfile();
  //console.log('message:', message);
  //console.log('userProfile:', userProfile);
  const hasImages = message.image && message.image.length > 0;
  const hasAttachments = message.attachments && message.attachments.length > 0 ? true : false;
  const isAutoText2Html = message.isAutoText2Html ? true : false;
  const hasHtmlContent = (!isAutoText2Html && message.htmlContent) ? true : false;

  const hasText = isAutoText2Html ? (message.htmlContent ?? message.text) : message.text;
  const isTyping = false;

  const chatUserFullName = chatUserDetails.firstName
    ? `${chatUserDetails.firstName} ${chatUserDetails.lastName}`
    : "-";

  const myProfile = (userProfile && userProfile.pictureUrl)
    ? userProfile.pictureUrl
    : imagePlaceholder;
  // console.log('userProfile:', userProfile);
  const senderImg = message2.senderId == -1 ? "/icons/chatbot.png" : message2.senderImg;
  const date = message.time ? Utils.GetShortDateTimeToShowInChat(message.time, false) : '';
  //const isSent = true;//message && message.meta ? message.meta.sent : true;
  const isSent = message && message.meta ? message.meta.sent : true;
  const readerPcnt = message.readerPcnt;
  const isRead = message2.isRead;//message.meta ? message.meta.read : true;
  const isForwarded = false;// message.meta ? message.meta.isForwarded : false;
  const fullName = isFromMe ? "Me" : message2.senderName;// isChannel ? channdelSenderFullname : chatUserFullName;

  const avImage0 = message2.senderId == 0 ? Const.IMG_AVATA_CHATBOT : (isFromMe ? message2.senderImg/*userProfile.pictureUrl*/ : message2.senderImg);
  const avForeColor = isFromMe && userProfile ? userProfile.foreColor : message2.senderForeColor;
  const avBackColor = isFromMe && userProfile ? userProfile.bgColor : message2.senderBgColor;
  const avAbbrName = isFromMe && userProfile ? userProfile.abbrName : message2.senderAbbrName;
  const avImage = ((avImage0 && avImage0.toLowerCase().includes("unknow_user.png") && avAbbrName)) ? "" : avImage0;  // clear image if it is unknow but have abbrName
  // console.log({avImage0, avForeColor, avBackColor, avAbbrName, avImage});

  const onDeleteMessage = () => {
    onDelete(message.mId);
  };

  const onClickReply = () => {
    onSetReplyData(message);
  };
  //const isRepliedMessage = message.replyOf;
  const isRepliedMessage = (message.replyOf && message.replyOf.mId) ? message.replyOf : null;

  const onForwardMessage = () => {
    onOpenForward(message);
  };

  const onDeleteImg = (imageId: number | string) => {
    onDeleteImage(message.mId, imageId);
  };

  const isDark = Utils.IsDarkTheme();

  const getLines = () => {
    let rawText = (message.text || "");
    if (isAutoText2Html) rawText = String(message.htmlContent);
    const tagNames = (message as any).tagNames;
    if (tagNames) {
      const tagArray = tagNames.split(Const.DELIM_ROW);
      for (let i = 0; i < tagArray.length; ++i) {
        const eachTag = tagArray[i].split(Const.DELIM_VALUE);
        const tagId = eachTag[0];
        const tagName = eachTag[1];
        const tagMe = tagId == userProfile.userId;
        const css = Utils.GetCssSuffixTheme('tag-name-' + (tagMe ? "me" : "other"));
        rawText = rawText.replaceAll(tagName, `<span class="${css}">${tagName}</span>`)
        // console.log({tagId, tagName});
      }
    }
    let lines = (rawText).split('\n'); // Fallback to an empty string  

    return lines;
  }

  const lines = getLines();// (message.text || "").split('\n'); // Fallback to an empty string


  // console.log('message:', message.respEmoji);
  const onEmojiClickFollow = (name: any, icon: any) => {
    if (Utils.IsViewAsAlert()) return;
    try {
      dispatch(setRespEmoji(message.mId, name, icon, displayName));
    } catch (e) {
      alert((e as any).message);
    }
  };

  const isAlignRight = isFromMe || (chatAlighRight == Const.UC_CHAT_ALIGH_RIGHT_COMP && message2.isSenderSameCompanyReader);

  const containerRef = useRef<HTMLDivElement>(null);
  const handleMessageClick = (e: React.MouseEvent) => {
    const target = e.target as HTMLElement;

    // Check if the clicked element is an image with stk-id
    if (target.tagName === 'IMG' && target.hasAttribute('stk-src')) {
      e.preventDefault();
      const stkSrc = target.getAttribute('stk-src');

      // Find all <img> elements with stk-id inside the container
      const container = containerRef.current;
      if (container) {
        const imgs = container.querySelectorAll('img[stk-src]');
        const stkImages = Array.from(imgs);

        // console.log('Clicked image stk-src:', stkSrc);
        // console.log('All images with stk-src:', stkImages);

        // Example: log all stk-id values
        let idx = 0;
        const urls: any[] = [];
        let selectedIndex = 0;
        stkImages.forEach(img => {
          urls.push({
            downloadLink: Utils.ConvertUrlIfItIsInternalChat(img.getAttribute('stk-src') ?? "")
          });
          if (img === e.target) {
            selectedIndex = idx;
          }
          idx++;
        });
        setStickerImages({
          selectedIndex: selectedIndex,
          images: urls
        });
      }
    }
  }

  const [stickerImages, setStickerImages] = useState<any>(null);
  // useEffect(() => { console.log('stickerImages:', stickerImages); }, [stickerImages]);

  return (
    <li
      m-id={message.mId}
      m-val={message.text}
      className={classnames(
        "chat-list",
        { right: isAlignRight },
        { reply: isRepliedMessage },
        { "read-no-dark": !isRead && isDark },
        { "read-no-light": !isRead && !isDark },
      )}
      is-from-me={message.isFromMe ? 1 : 0}
      is-read={isRead ? 1 : 0}

    >
      <div className="conversation-list" onClick={handleMessageClick} ref={containerRef} >
        <div className="chat-avatar">
          <UserAvatar
            profileImage={avImage}
            bgColor={avBackColor}
            foreColor={avForeColor}
            abbrName={avAbbrName}
            size={"sm"}
            includeDivContainer={true}
          />
          {/* <img
            src={isFromMe ? myProfile : senderImg}
            alt=""
            onError={(e) => { (e.currentTarget as HTMLImageElement).src = '/icons/user-dummy-img.jpg'; }}
          /> */}
        </div>

        <div className="user-chat-content ">

          <div className="conversation-name">
            {isFromMe ? (
              <>
                <SenderMsgInfo senderId={message.senderId} isSent={isSent} sentDate={date} readPcnt={readerPcnt} msgId={message.mId} onViewReadStatus={onViewReadStatus} />
              </>
            ) : (
              <>
                {/* 20261021 employee sees read status of every message, not only own messages */}
                {curUserType == UserTypes.Employee && (
                  <span className="me-1 d-inline-block align-middle">
                    <ReadPcntCircle pcnt={readerPcnt ?? 0} msgId={message.mId} onViewReadStatus={onViewReadStatus} />
                  </span>
                )}
                {message2.senderId == -1 ? "บอท" : message2.senderName}
                <small className={classnames("text-muted", "mb-0", "ms-2")}>
                  {date}
                </small>
              </>
            )}
          </div>


          {/* เปลี่ยนไปแสดง image อยู่กับข้อความ */}
          {/* {hasImages && message.text &&  (
            <div className="ctext-wrap">
              <div className="ctext-wrap-content">
                <p className="mb-0 ctext-content">{message.text}</p>
              </div>
            </div>
          )} */}
          {isForwarded && (
            <span
              className={classnames(
                "me-1",
                "text-muted",
                "font-size-13",
                "mb-1",
                "d-block"
              )}
            >
              <i
                className={classnames(
                  "ri",
                  "ri-share-forward-line",
                  "align-middle",
                  "me-1"
                )}
              ></i>
              Forwarded
            </span>
          )}

          <div className="ctext-wrap">
            {/* text message end */}

            {/* image message start */}
            {hasImages && false ? ( /* เปลี่ยนแป็นแสดง image ปนกับข้อความ เพื่อความสะดวกตอนทำ emoji resp message */
              <><Images images={message.image!} message={message} onSetReplyData={onSetReplyData} onDeleteImg={onDeleteImg} /></>
            ) : (
              <>
                {message2.isUnsend && (
                  <div className="ctext-wrap-content">
                    <span className="msg-unsend">
                      -- {message2.isFromMe ? ('คุณ') : (message2.senderName)}&nbsp;ยกเลิกข้อความ --
                    </span>
                  </div>
                )}

                {!message2.isUnsend && (
                  <div className="ctext-wrap-content">
                    {isRepliedMessage && (<RepliedMessage fullName={fullName} message={message} isFromMe={isFromMe} onClickReplyMsg={onClickReplyMsg} />)}

                    {hasText && !hasHtmlContent && (
                      // <p className="mb-0 ctext-content">{message.text}</p>
                      <p className="mb-0 ctext-content text-start " >
                        {lines.map((line, index) => (
                          <span key={index} >
                            <span dangerouslySetInnerHTML={{ __html: line }} /> {/* Render raw HTML */}
                            {index < lines.length - 1 && <br />} {/* Add a line break except for the last line */}
                          </span>
                        ))}
                      </p>

                    )}
                    {/* typing start */}
                    {isTyping && <Typing />}

                    {/* typing end */}
                    {/* files message start */}

                    {hasAttachments && (<Attachments attachments={message.attachments} />)}
                    {hasHtmlContent && (<HtmlContent htmlContent={message.htmlContent} />)}
                    {hasImages && (<Images images={message.image!} message={message} onSetReplyData={onSetReplyData} onDeleteImg={onDeleteImg} />)}


                    {/* files message end */}

                    {/* emoji respond */}
                    {message.respEmoji && message.respEmoji.length > 0 && (
                      <p className="mb-0 ctext-content text-start msg-emoji-show-p" >
                        {message.respEmoji.filter((e: any) => e.memberNames).map((emo: any, key: number) => (
                          <div key={key} className={"msg-emoji-show-p-div " + Utils.GetCssSuffixTheme("msg-emoji-show-p-div-") + (isFromMe ? "-me" : "-oh")}>
                            <span className="hand" onClick={() => onEmojiClickFollow(emo.emojiName, emo.emoji)}>{emo.emoji}</span>&nbsp;
                            <span>{emo.memberNames.replaceAll(Const.EMOJI_MEMBER_SPLITTER, ", ")}</span>
                          </div>
                        ))}
                      </p>
                    )}
                  </div>
                )}
                {!message2.isUnsend && (
                  <Menu
                    onForward={onForwardMessage}
                    onDelete={onDeleteMessage}
                    onReply={onClickReply}
                    msgId={message.mId}
                    isFromMe={message.isFromMe}
                    showAiMenu={curUserType == UserTypes.Employee && groupType == UserTypes.Group}
                  />
                )}
              </>
            )}

            {/* image message end */}
          </div>

        </div>
      </div>

      {stickerImages && (
        <LightBox2
          isOpen={stickerImages ? true : false}
          images={stickerImages.images}
          onClose={() => { setStickerImages(null) }}
          defaultIdx={stickerImages.selectedIndex}
          allowRotate={false}
        />
      )}

    </li>
  );
};

export default Message;
